export const dStocks = [
    {
        symbol: "AAPL",
        name: "Apple"
    },

     {
        symbol: "AMZN",
        name: "Amazon"
    },

    {
        symbol: "BABA",
        name: "Alibaba"
    },

    {
        symbol: "COIN",
        name: "Coinbase"
    },

    {
        symbol: "GME",
        name: "Gamestop"
    },

    {
        symbol: "GOOGL",
        name: "Google"
    },

    {
        symbol: "NVDA",
        name: "Nvidia"
    },

    {
        symbol: "PLTR",
        name: "Palantir"
    },

    {
        symbol: "TSLA",
        name: "Tesla"
    },

    {
        symbol: "ARKK",
        name: "New Tech."
    },

    {
        symbol: "GLD",
        name: "Gold"
    },

    {
        symbol: "SLV",
        name: "Silver"
    },

    {
        symbol: "PDBC",
        name: "Commodities"
    },

    {
        symbol: "QQQ",
        name: "Nasdaq"
    },

    {
        symbol: "SPY",
        name:	"S&P"
    },

    {
        symbol: "TLT",
        name:	"US Treas. 20Y"
    },

    {
        symbol: "URTH",
        name:	"MSCI World"
    },

    {
        symbol: "VNQ",
        name:	"Real Estate"
    },

    {
        symbol: "EEM",
        name:	"Emerg.Markets"
    },

    {
        symbol: "FB",
        name:	"Facebook"
    },

    {
        symbol: "MSFT",
        name:	"Microsoft"
    },

    {
        symbol: "NFLX",
        name:	"Netflix"
    },

    {
        symbol: "VOO",
        name:	"S&P ETF"
    },

    {
        symbol: "DIS",
        name:	"Disney"
    },

    {
        symbol: "MSTR",
        name:	"Microstrat."
    },

    {
        symbol: "MCHI",
        name:	"MSCI China"
    },

    {
        symbol: "INTC",
        name:	"Intel"
    },

    {
        symbol: "BRK.B",
        name:	"Berkshire"
    },

    {
        symbol: "PYPL",
        name:	"Paypal"
    },

    {
        symbol: "PG",
        name:	"Procter&Gm."
    },

    {
        symbol: "KO",
        name:	"CocaCola"
    },

    {
        symbol: "CS",
        name:	"Credit Suisse"
    },

    {
        symbol: "SAP",
        name:	"SAP SE"
    },

    {
        symbol: "GSG",
        name:	"Commod. ETF"
    },

    {
        symbol: "URA",
        name:	"Uran ETF"
    },

    {
        symbol: "XOM",
        name:	"Exxon"
    },

    {
        symbol: "GOVT",
        name:	"US Treas. ETF"
    },

    {
        symbol: "TAN",
        name:	"Solar ETF"
    },

    {
        symbol: "PPLT",
        name:	"Platinum ETF"
    },

    {
        symbol: "JNJ",
        name:	"Johnson & J."
    },

    {
        symbol: "DAX",
        name:	"Dax ETF"
    },

    {
        symbol: "ADDYY",
        name:	"Adidas"
    },

    {
        symbol: "GS",
        name:	"Goldm. Sachs"
    },

    {
        symbol: "UNG",
        name:	"US Gas Fund"
    },

    {
        symbol: "USO",
        name:	"US Oil Fund"
    },

    {
        symbol: "WMT",
        name:	"Walmart"
    },

    {
        symbol: "UL",
        name:	"Unilever"
    },

    {
        symbol: "ARKX",
        name:	"Space ETF"
    },

    {
        symbol: "VBK",
        name:	"Sm.Caps ETF"
    },

    {
        symbol: "XLRE",
        name:	"Real Est. ETF"
    },

    {
        symbol: "XLE",
        name:	"Energy Fund"
    },

    {
        symbol: "NSRGY",
        name:	"Nestle"
    },

    {
        symbol: "SH",
        name:	"Short S&P ETF"
    },

    {
        symbol: "SHEL",
        name:	"Shell"
    },

    {
        symbol: "BITI",
        name:	"BTC Inv ETF"
    },

]

export default dStocks
